<template>
  <div class="login">
    <div class="loginBox">
      <h1 class="loginLogo"><span class="loginLogo__inner">Gaby</span></h1>
      <form div class="loginBox__content" @submit.prevent="submit">
        <div class="form__group">
          <label class="form__label" for="email">Email:</label>
          <span class="form__error" v-if="errors.has('email')">{{ errors.first('email') }}</span>
          <input
            type="email" name="email"
            class="form__input" :class="{ 'form__input--error': errors.has('email') }"
            v-validate="{ required: true, email: true}"
            v-model="user.email"
          >
        </div>
        <div class="form__group">
          <label class="form__label" for="password">Password:</label>
          <span class="form__error" v-if="errors.has('password')">{{ errors.first('password') }}</span>
          <input
            type="password" name="password"
            class="form__input"  :class="{ 'form__input--error': errors.has('password') }"
            v-validate="{ required: true }"
            v-model="user.password"
          >
        </div>
        <div>
          <button type="submit" class="btn btn--primary">
            <font-awesome-icon :icon="['fal', 'sign-in']" /> Sign in
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import displayError from '@/helpers/displayError'

export default {
  data () {
    return {
      user: {
        email: '',
        password: ''
      }
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios.post(`/sessions`, { session: this.user }).then((response) => {
            this.$auth.setToken(response.data.access_token)

            this.$auth.getUserInfo(response.data.access_token).then(() => {
              this.$router.push({name: 'dashboard'})
            })
          }, (response) => {
            displayError(response)
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auth/Login.vue